import { httpV1 as http } from '@/services/api';

export async function getBankAccountInfoByPix(params) {
  return http.get('/payments/bank-account/info', { params });
}

export async function getBankAccountInfoByPixForPromoters(params) {
  return http.get('/payments/bank-account-commission/info', { params });
}
